"use strict";

exports.__esModule = true;
exports.mapGraphQLToProductOptions = void 0;
const fieldMappings = {
  Product_Title: 'label',
  Description_Long: 'description',
  Aroma_Scent: 'scent',
  Ingredients: 'ingredients',
  Net_Content_Statement: 'netContentStatement',
  Directions_for_Use: 'directionsForUse',
  Safety_Warnings: 'safetyWarnings'
};

const mapGraphQLToProductOptions = data => {
  const transformNode = node => {
    var _productData$heroImag, _productData$heroImag2, _node$categories;

    if (!node.fields || !node.fields.productData) {
      return null;
    }

    const {
      productData
    } = node.fields;
    const features = {};
    Object.keys(productData).forEach(key => {
      const mappedKey = fieldMappings[key];

      if (mappedKey) {
        features[mappedKey] = productData[key];
      } else {
        features[key] = productData[key];
      }
    });
    const productDetails = {
      label: productData.Product_Title || '',
      value: productData.sku || '',
      features,
      image: {
        props: {
          src: ((_productData$heroImag = productData.heroImage) === null || _productData$heroImag === void 0 ? void 0 : _productData$heroImag.url) || '',
          alt: ((_productData$heroImag2 = productData.heroImage) === null || _productData$heroImag2 === void 0 ? void 0 : _productData$heroImag2.alt) || ''
        }
      },
      url: node.url || '',
      category: ((_node$categories = node.categories) === null || _node$categories === void 0 ? void 0 : _node$categories.title) || ''
    };
    return productDetails;
  };

  const nodes = data.nodes || [];
  return nodes.map(transformNode).filter(product => product !== null);
};

exports.mapGraphQLToProductOptions = mapGraphQLToProductOptions;